import { render, staticRenderFns } from "./LongPressButton.vue?vue&type=template&id=7b6662c4&scoped=true&"
import script from "./LongPressButton.vue?vue&type=script&lang=js&"
export * from "./LongPressButton.vue?vue&type=script&lang=js&"
import style0 from "./LongPressButton.vue?vue&type=style&index=0&id=7b6662c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6662c4",
  null
  
)

export default component.exports